module.exports = __webpack_public_path__ + "img/dryad_small.0d3912fb.png";